<div class="row">
  <h2 class="col-12"><i class="fas fa-server"></i> Technical sender domain</h2>
</div>

<div class="d-flex flex-column add">
  <div class="d-flex align-items-center" [formGroup]="createForm">
    <select
      class="form-control"
      formControlName="accountId"
      (change)="fetch($event.target.value)"
    >
      <option value="" selected="selected">Choose account</option>
      <option *ngFor="let account of accounts$ | async" [value]="account.id">
        {{ account.displayName }} ({{ account.id }})
      </option>
    </select>
    <div class="input-group">
      <input
        placeholder="Add from domain"
        type="text"
        class="form-control form-control-sm"
        formControlName="fromDomain"
      />
    </div>
    <div class="input-group">
      <input
        placeholder="Add new technical sender domain"
        type="text"
        class="form-control form-control-sm"
        formControlName="senderDomain"
      />
    </div>
    <button
      class="btn btn-success"
      [disabled]="createForm.invalid"
      (click)="create()"
    >
      <i class="fas fa-plus"></i> Create new technical sender domain
    </button>
  </div>
</div>

<div class="d-flex justify-content-between align-items-center">
  <div class="header">Accounts with technical sender domain</div>
</div>

<div class="no-gutters">
  <div class="input-group col-4">
    <div class="input-group-prepend">
      <span class="input-group-text"><i class="fas fa-search"></i></span>
    </div>
    <input
      placeholder="Filter account or domain"
      type="text"
      class="form-control form-control-sm"
      (input)="filter$.next($event.target.value)"
    />
  </div>
</div>

<app-table class="d-flex">
  <app-table-headers>
    <app-table-header> Account </app-table-header>
    <app-table-header> From domain </app-table-header>
    <app-table-header> Technical sender domain </app-table-header>
    <app-table-header> Valid Cname record </app-table-header>
    <app-table-header> Delete </app-table-header>
  </app-table-headers>

  <app-table-content>
    <app-table-row *ngFor="let senderDomain of senderDomains$ | async">
      <app-table-cell>{{ senderDomain.accountId }}</app-table-cell>
      <app-table-cell>{{ senderDomain.fromDomain }}</app-table-cell>
      <app-table-cell>{{ senderDomain.technicalSenderDomain }}</app-table-cell>
      <app-table-cell>{{ senderDomain.isValid ? 'Yes' : 'No' }}</app-table-cell>
      <app-table-cell class="justify-content-center">
        <button
          class="btn btn-danger btn-sm"
          title="Delete"
          (click)="delete(senderDomain.id, senderDomain.accountId)"
        >
          <i class="fas fa-trash"></i>
        </button>
      </app-table-cell>
    </app-table-row>
  </app-table-content>
</app-table>
